import { AddUpdateVersionForceGroupRequest } from '../../models/ss-api/requests/add.update.version.force.group.request';
import { UpdateVersionForceGroupItem } from '../../models/domain/update.version.force.group.item';
import { AddUpdaterVersionRequest } from '../../models/ss-api/requests/add.updater.version.request';
import { UpdateUpdaterVersionRequest } from '../../models/ss-api/requests/update.updater.version.request';
import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from '../../services/modal-dialogs';
import { ssApiService } from '../../services/ss-api.service';
import { GlobalService } from '../../services/global.service';
import { SweetAlertService } from 'ng2-cli-sweetalert2';
import { Router } from '@angular/router';
import { UpdaterVersionItem } from '../../models/domain/updater.version.item';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { IUpdateUpdaterVersionTemplate } from '../update.updater/update.updater.dialog';
import { VersionItemArray } from '../../models/domain/version.item';
import { EditUpdateVersionForceGroupRequest } from '../../models/ss-api/requests/edit.update.version.force.group.request';
import { LiveHubService } from '../../services/livehub.service';

export interface IUpdateGroupTemplate {
    Title: string;
    Group?: UpdateVersionForceGroupItem;
}

@Component({
    selector: 'update-group-dialog',
    styleUrls: ['./update.group.dialog.scss'],
    templateUrl: './update.group.dialog.html'
})

export class UpdateGroupDialog extends DialogComponent<IUpdateGroupTemplate, boolean> implements IUpdateGroupTemplate, OnInit {
    IsBusy: boolean;
    Title: string;
    Group: UpdateVersionForceGroupItem;

    Versions: VersionItemArray;

    GroupForm: FormGroup;

    constructor(private api: ssApiService, dialogService: DialogService, private gb: GlobalService, private sweetAlert: SweetAlertService, public router: Router, private liveHub: LiveHubService) {
        super(dialogService, router);
    }

    ngOnInit() {
        this.IsBusy = false;
        if (!this.Group) {
            this.Group = new UpdateVersionForceGroupItem();
        }

        this.GroupForm = new FormGroup({
            'Name': new FormControl(this.Group.Name, [Validators.required]),
            'Description': new FormControl(this.Group.Description, [Validators.required]),
            'VersionItem_ID': new FormControl(this.Group.VersionItem_ID, [Validators.required]),
            'IsDefault': new FormControl(this.Group.IsDefault)
        });

        this.LoadVersions();
    }

    LoadVersions() {
        let disposable = this.api.GetActiveV3Versions().subscribe(response => {
            this.Versions = response.Data;
            disposable.unsubscribe();
        });
    }

    DeleteGroup() {
        this.sweetAlert.swal({
            type: 'warning',
            title: 'Are you sure?',
            text: 'This action cannot be undone',
            showCancelButton: true,
            preConfirm: () => {
                return this.api.DeleteUpdateVersionForceGroup(this.Group.ID).toPromise();
            }
        }).then( (response) => {
            if (response.Result) {
                this.sweetAlert.swal({
                    type: 'success',
                    title: 'Success',
                    text: 'Group deleted successfully',
                    timer: 1500
                }).then( () => {
                    this.result = true;
                    this.close();
                }, () => {
                    this.result = true;
                    this.close();
                } );
            } else {
                this.sweetAlert.swal({
                    type: 'error',
                    title: 'Error',
                    text: response.Message,
                    timer: 1500
                }).then( () => { }, () => { } );
            }
        }, () => {});
    }

    PushGroup() {
        this.IsBusy = true;

        if (!this.GroupForm.valid) return false;

        let controls = this.GroupForm.controls;

        let request: EditUpdateVersionForceGroupRequest = {
            UpdateVersionForceGroupID: this.Group.ID,
            Name: controls['Name'].value,
            Description: controls['Description'].value,
            VersionItem_ID: controls['VersionItem_ID'].value,
            IsDefault: controls['IsDefault'].value
        };

        let disposable = this.api.EditUpdateVersionForceGroup(request).subscribe(response => {
            if (response.Result) {
                this.sweetAlert.swal({
                    type: 'success',
                    title: 'Success',
                    text: 'Group pushed to members',
                    timer: 1500
                }).then( () => {
                    // Only invoke Hub on success
                    this.liveHub.InvokeConnection('NotifyUpdateVersionForceGroupMembersOfNewVersion', this.Group.ID);
                    this.result = true;
                    this.close();
                }, () => {
                    this.result = true;
                    this.close();
                } );
            } else {
                this.sweetAlert.swal({
                    type: 'error',
                    title: 'Error',
                    text: response.Message,
                    timer: 1500
                }).then( () => { }, () => { } );
            }
            disposable.unsubscribe();
            this.IsBusy = false;
        });
    }

    confirm() {
        this.IsBusy = true;

        if (!this.GroupForm.valid) return false;

        let controls = this.GroupForm.controls;

        if (this.Group.ID) {
            let request: EditUpdateVersionForceGroupRequest = {
                UpdateVersionForceGroupID: this.Group.ID,
                Name: controls['Name'].value,
                Description: controls['Description'].value,
                VersionItem_ID: controls['VersionItem_ID'].value,
                IsDefault: controls['IsDefault'].value
            };

            let disposable = this.api.EditUpdateVersionForceGroup(request).subscribe(response => {
                if (response.Result) {
                    this.sweetAlert.swal({
                        type: 'success',
                        title: 'Success',
                        text: 'Group updated successfully',
                        timer: 1500
                    }).then( () => {
                        this.liveHub.InvokeConnection('NotifyUpdateVersionForceGroupMembersOfNewVersion', this.Group.ID);
                        this.result = true;
                        this.close();
                    }, () => {
                        this.liveHub.InvokeConnection('NotifyUpdateVersionForceGroupMembersOfNewVersion', this.Group.ID);
                        this.result = true;
                        this.close();
                    } );
                } else {
                    this.sweetAlert.swal({
                        type: 'error',
                        title: 'Error',
                        text: response.Message,
                        timer: 1500
                    }).then( () => { }, () => { } );
                }
                disposable.unsubscribe();
                this.IsBusy = false;
            });
        } else {
            let request: AddUpdateVersionForceGroupRequest = {
                Name: controls['Name'].value,
                Description: controls['Description'].value,
                VersionItem_ID: controls['VersionItem_ID'].value,
                IsDefault: controls['IsDefault'].value
            };

            let disposable = this.api.AddUpdateVersionForceGroup(request).subscribe(response => {
                if (response.Result) {
                    this.sweetAlert.swal({
                        type: 'success',
                        title: 'Success',
                        text: 'Group created successfully',
                        timer: 1500
                    }).then( () => {
                        this.liveHub.InvokeConnection('NotifyUpdateVersionForceGroupMembersOfNewVersion', this.Group.ID);
                        this.result = true;
                        this.close();
                    }, () => {
                        this.liveHub.InvokeConnection('NotifyUpdateVersionForceGroupMembersOfNewVersion', this.Group.ID);
                        this.result = true;
                        this.close();
                    } );
                } else {
                    this.sweetAlert.swal({
                        type: 'error',
                        title: 'Error',
                        text: response.Message,
                        timer: 1500
                    }).then( () => { }, () => { } );
                }
                disposable.unsubscribe();
                this.IsBusy = false;
            });
        }

    }

}
